module.exports = __webpack_public_path__ + "media/packs/images/state/pol-d6baaa2a693056e33b723204d56d526f.svg";